import React from 'react';

const features = [
  'Real-time Conversation',
  'Sentiment Analysis',
  'Medical Diagnosis Training',
  'Communication Skills Focus',
  'Faculty Customization',
  'Interactive VR/3D',
  'Scalability in Curricula',
  'Longitudinal Patient Memory',
];

const competitors = [
  { name: 'SILO', values: [true, true, true, true, true, 'Optional', true, true] },
  { name: 'Osso VR', values: [false, false, true, false, false, true, true, false] },
  { name: 'Shadow Health', values: [true, false, true, true, false, false, true, false] },
  { name: 'Lifelike', values: [true, true, true, false, false, false, false, false] },
  { name: 'Simbo.ai', values: [false, false, true, false, true, false, true, false] }, // Corrected name from Simboix to Simbo.ai
  { name: 'Body Interact', values: [false, false, true, false, false, true, true, false] },
];

const CompetitorComparisonSection: React.FC = () => (
  <section id="competitor-comparison" style={{ background: '#f6fcfc', padding: '4rem 0', textAlign: 'center' }}>
    <h2 style={{ fontSize: '2.5rem', fontWeight: 800, marginBottom: '1rem' }}>
      Competitor Comparison & Market Positioning
    </h2>
    <p style={{ color: '#666', fontSize: '1.25rem', marginBottom: '3rem', maxWidth: '900px', margin: '0 auto 3rem auto' }}>
      See how SILO stands out from other medical simulation platforms.
    </p>
    <div style={{ maxWidth: 1400, margin: '0 auto', overflowX: 'auto', padding: '0 1rem' }}>
      <table style={{ width: '100%', borderCollapse: 'collapse', minWidth: '900px' }}>
        <thead>
          <tr>
            <th style={{ textAlign: 'left', padding: '1rem 0.75rem', borderBottom: '2px solid #e0e0e0', fontSize: '1.1rem', color: '#555', fontWeight: 600, width: '20%' }}>Feature</th>
            {competitors.map(c => (
              <th key={c.name} style={{ 
                padding: '1rem 0.75rem', 
                borderBottom: '2px solid #e0e0e0', 
                fontSize: '1.1rem', 
                color: '#333', 
                fontWeight: 700,
                width: '16%',
                background: c.name === 'SILO' ? 'rgba(34, 58, 94, 0.08)' : 'transparent',
                borderLeft: c.name === 'SILO' ? '2px solid #223A5E' : 'none',
                borderRight: c.name === 'SILO' ? '2px solid #223A5E' : 'none'
              }}>{c.name}</th>
            ))}
          </tr>
        </thead>
        <tbody>
          {features.map((feature, i) => (
            <tr key={feature}>
              <td style={{ textAlign: 'left', padding: '1rem 0.75rem', borderBottom: '1px solid #eee', fontSize: '1rem', color: '#444', fontWeight: 500 }}>{feature}</td>
              {competitors.map(c => (
                <td key={`${c.name}-${feature}`} style={{ 
                  padding: '1rem 0.75rem', 
                  borderBottom: '1px solid #eee', 
                  fontSize: '1.25rem', 
                  color: c.values[i] === true || c.values[i] === 'Optional' ? '#223A5E' : '#aaa',
                  background: c.name === 'SILO' ? 'rgba(34, 58, 94, 0.08)' : 'transparent',
                  borderLeft: c.name === 'SILO' ? '2px solid #223A5E' : 'none',
                  borderRight: c.name === 'SILO' ? '2px solid #223A5E' : 'none'
                }}>
                  {typeof c.values[i] === 'boolean' ? (c.values[i] ? '✔️' : '❌') : c.values[i]}
                </td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  </section>
);

export default CompetitorComparisonSection; 